import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useOutsideClick from 'useOutsideClick';
import '../../../TransactionsList.scss';

function LinkedTransactions(props) {
  const { transactions, tableHead, renderTransactionRow, onClose } = props;
  const popupRef = useRef();

  useOutsideClick({ ref: popupRef, callback: onClose });

  return (
    <div>
      {tableHead()}
      {transactions.map((item) => renderTransactionRow(item, true, false))}
    </div>
  );
}

LinkedTransactions.propTypes = {
  transactions: PropTypes.array,
  tableHead: PropTypes.func,
  renderTransactionRow: PropTypes.func,
  onClose: PropTypes.func,
};

export default LinkedTransactions;
